<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="main-card-component">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-icon color="darkColor">mdi-ambulance</v-icon>
                <span class="modal-title-text mr-2">استقرار جدید</span>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row>
                  <v-col cols="7">
                    <v-row>
                      <v-col cols="6">
                        <v-autocomplete :items="missionInformTypeItems" no-data-text="اطلاعاتی وجود ندارد" dense
                          outlined item-text="title" item-value="id" label="نوع درخواست" clearable
                          clear-icon="mdi-close-circle-outline" autocomplete="off"
                          prepend-inner-icon="mdi-car-emergency mdi-18px"
                          v-model="deploymentInformTypeId"></v-autocomplete>
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                          item-text="title" item-value="id" label="اولویت" clearable
                          clear-icon="mdi-close-circle-outline" autocomplete="off"
                          prepend-inner-icon="mdi-car-emergency mdi-18px" v-model="deploymentRank"></v-autocomplete>
                      </v-col>
                      <v-col cols="6" class="mt-n8">
                        <v-text-field dense @keypress="isNumberWithSpace($event)" maxlength="11" outlined
                          label="تلفن پیگیری" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px" clearable
                          clear-icon="mdi-close-circle-outline" v-model="deploymentRecoveryPhone"></v-text-field>
                      </v-col>
                      <v-col cols="6" class="mt-n8">
                        <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                          item-text="title" item-value="id" label="َشهر" clearable clear-icon="mdi-close-circle-outline"
                          autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px" return-object
                          v-model="deploymentSelectedCity"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="mt-n8">
                        <v-row>
                          <v-col cols="9">
                            <v-text-field dense outlined label="آدرس" prepend-inner-icon="mdi-map-marker mdi-18px"
                              clearable clear-icon="mdi-close-circle-outline"
                              v-model="deploymentAddress"></v-text-field>
                          </v-col>
                          <v-col cols="3" class="mt-n2">
                            <v-checkbox label="تایید موقعیت" hide-details
                              v-model="acceptLocationDeployment"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-n8">
                        <v-text-field dense outlined label="توضیحات" prepend-inner-icon="mdi-text mdi-18px" clearable
                          clear-icon="mdi-close-circle-outline" v-model="deploymentNote"></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-n8">
                        <v-autocomplete :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                          item-text="title" item-value="id" label="برچسب ها" clearable
                          clear-icon="mdi-close-circle-outline" autocomplete="off" chips multiple small-chips
                          prepend-inner-icon="mdi-label mdi-flip-h mdi-18px" v-model="deploymentTag"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" class="mt-n8">
                        <v-row no-gutters>
                          <v-col cols="12" class="select-code-box">
                            <v-row>
                              <v-col cols="6" class="mt-1 mr-1">
                                <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد"
                                  dense outlined item-text="title" item-value="id" label="کد پیشنهادی" return-object
                                  clearable clear-icon="mdi-close-circle-outline" autocomplete="off"
                                  prepend-inner-icon="mdi-medication mdi-18px"
                                  v-model="deploymentVehicleType"></v-autocomplete>
                              </v-col>
                              <v-col cols="4" class="mt-1">
                                <v-text-field dense outlined @keypress="isNumber($event)" label="تعداد"
                                  prepend-inner-icon="mdi-numeric mdi-18px" clearable
                                  clear-icon="mdi-close-circle-outline"
                                  v-model="deploymentVehicleCounte"></v-text-field>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="1" class="mt-1">
                                <v-btn color="darkColor" elevation="0" block @click="addCodeForDeploymentMission()">
                                  <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row class="mr-1 mt-n5">
                              <span v-for="item in listOfDeploymentSelectedCodes" :key="item.id"
                                class="selected-code mr-2 mt-1">
                                {{ item.title }} ( {{ item.count }} )
                                <v-icon @click="removeCodeFromDeploymentMission(item.id)" class="mr-2">
                                  mdi-close mdi-18px
                                </v-icon>
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="5">
                    <v-row>
                      <v-col cols="12">
                        <!-- <v-text-field
                          outlined
                          rounded
                          dense
                          label="جستجو..."
                          v-on:keyup.enter="searchForGeoLocation()"
                          append-icon="mdi-magnify"
                          v-model="searchGeoLocationTextForDeployment"
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              elevation="0"
                              fab
                              dark
                              x-small
                              color="darkColor"
                              @click="searchForGeoLocation()"
                            >
                              <v-icon dark>mdi-map-marker-down</v-icon>
                            </v-btn>
                          </template></v-text-field> -->
                        <map-search-field @address-search="onSearchSuggestion" :maxMinSearchProp="false" />
                      </v-col>
                      <v-col cols="12">
                        <div v-if="isMapReadyToShow" id="map">
                          <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 50vh !important"
                            @click="addMarker" :zoom="zoom" :center="center" :options="mapOptions"
                            @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                            <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                            <l-control position="bottomleft" class="mb-n6" v-if="latLngForShow">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field outlined rounded dense disabled class="latlng-map-input"
                                    v-model="latLngForShow"></v-text-field>
                                </v-col>
                              </v-row>
                            </l-control>
                            <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                            <!-- Marker -->
                            <l-marker v-if="position && position.lat && position.lng" visible draggable :icon="icon"
                              :lat-lng.sync="position" @dragstart="dragging = true"
                              @dragend="dragging = false"></l-marker>
                          </l-map>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mb-3">
            <v-row no-gutters>
              <v-col cols="2" class="mt-6 mr-3">
                <v-row>
                  <span>مدت زمان تکمیل فرم:</span>
                  <h4 class="time-passed mr-2">{{ showPassedTime }}</h4>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="ml-5">
                <v-btn color="darkColor" dark rounded block @click="activeNewDeploymentMissionFunction()"
                  class="normal-letter-spacing">
                  ارجاع به 800
                </v-btn>
              </v-col>
              <v-col cols="2">
                <v-btn color="darkColor" rounded block @click="cancleDeployment()" outlined
                  class="normal-letter-spacing">
                  انصراف
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import AlertComponent from '@/components/AlertComponent.vue';
import ShearedHelper from '@/Helpers/Shared.js';
import deploymentFormHelper from '@/Helpers/115/deploymentFormHelper.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import cityMixin from '@/Mixins/BaseInformation/CityMixin';
import ServiceMixin from '@/Mixins/ServiceMixin';
import TagMixin from '@/Mixins/BaseInformation/TagMixin.js';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import MapMixin from '@/Mixins/115/MapMixin.js';
import SharedMap from '@/Mixins/map';
import MapSearchField from '@/components/app/map/search.vue';
import SerachMapMixin from '@/components/app/map/SerachMapMixin.js';

export default {
  name: 'DeploymentForm',
  title: 'تماس جدید',
  inject: ['load'],
  components: {
    AlertComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    MapSearchField,
  },
  mixins: [
    snackBar,
    ShearedMixin,
    cityMixin,
    ServiceMixin,
    ShearedHelper,
    TagMixin,
    VehicleTypeMixin,
    MissionMixin,
    MapMixin,
    deploymentFormHelper,
    SharedMap,
    SerachMapMixin,
  ],
  created() {
    this.$root.$refs.DeploymentForm = this;
    this.toggleTimer();
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      setTimeOut: 0,
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: null,
      dragging: false,
      icon: this.getIcon,
    };
  },
  methods: {
    mounte: function () {
      this.deploymentFormLoad = true;
      this.deploymentInformTypeId = 1;
      this.deploymentRank = 0;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.setMapBaseSystemSetting();

      this.getListOfCitysForOther();
      // this.getAllCurrentMissionForFormFunction();
      this.getListOfVehicleTypesForOther();
      this.getListOfTagsForOther();
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    addMarker(event) {
      this.position = event.latlng;
      this.latLngForShow = 'lat: ' + event.latlng.lat + ' ' + 'lng: ' + event.latlng.lng;
      this.getMapReverseGeoCode(event.latlng);
    },
  },
  watch: {
    isMapReadyToShow: function (currentValue) {
      if (currentValue) {
        this.setTimeOut = setTimeout(() => {
          const map = this.$refs.modalmap.mapObject;
          map.addControl(new window.L.Control.Fullscreen());
        }, 100);
      }
    },
  },
  beforeDestroy() {
    this.mapInvalidate();
    this.centerUpdate();
    this.zoomUpdate();
    clearTimeout(this.setTimeOut);
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
  height: 7vh !important;
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

>>>.v-chip.v-size--small {
  font-size: 9px !important;
  height: 20px !important;
  padding-left: 3px !important;
  padding-right: 3px !important;
  border-radius: 9px !important;
}

.select-code-box {
  border: 1px solid #212121 !important;
  border-radius: 5px !important;
  height: 19vh !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.selected-code {
  background: var(--background-color) !important;
  padding-left: 7px !important;
  padding-right: 7px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}

.main-card-component {
  overflow-y: auto !important;
}

>>>.latlng-map-input fieldset {
  background: white !important;
}

>>>.latlng-map-input .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.latlng-map-input.v-input input {
  max-height: 30px !important;
}

.latlng-map-input {
  width: 350px;
  min-width: 350px;
  max-width: 350px;
}
</style>
